import React, {useEffect, useState, useRef, useContext} from 'react'
import Menu from '../../components/Menu/Menu'
import './Home.scss'
import axios from 'axios';
import { REACT_APP_WORKING_URL, REACT_APP_WORKING_CHATAPI_URL } from '../../Constants'
import Feedbacks from '../../components/Feedbacks/Feedbacks';
import { useNavigate } from 'react-router-dom';
import {message, Drawer, Popover, Dropdown, Space, Button, Checkbox, Flex  } from 'antd';
import StoredUserContext from '../../context/StoredUserContext';
import {
  EllipsisOutlined,
  DownOutlined 
} from '@ant-design/icons';


const items = [
  {
    label: <span>Select More</span>,
    key: '0',
  },
  // {
  //   type: 'divider',
  // },
];

function Home() {
  // 环境变量
  const apiUrl = REACT_APP_WORKING_URL
  const apiUrlChat = REACT_APP_WORKING_CHATAPI_URL
  const stream = useRef(null);
  const record = useRef(null);
  const blobs = useRef([]);
  const blob = useRef(null);
  const navigate = useNavigate();


  const scrollableDivRef = useRef(null);
  const [inputValue, setInputValue] = useState(''); 
  const [chatList, setChatList] = useState([])
  const [chatgptlLogging, setChatgptLogging] = useState(false)
  const [isSpeaking, setIsSpeaking] = useState(false)
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState('');
  const [showSelect, setShowSelect] = useState(false);
  const [selectedSet, setSelectedSet] = useState(new Set());
  const user = JSON.parse(localStorage.getItem('user'));
  const [contextUser, setContextUser] = useContext(StoredUserContext);


  useEffect(()=>{
    axios.get(`${apiUrl}chatting/findLastThreeHistory/${user.user_id}`,{
        headers: {
          authorization: `Bearer ${user.accessToken}`,
        },
      }
    )
    .then((res)=>{
      const newArray = []
      if(res.data && res.data.length > 3){
        res.data.slice(-3).forEach((item)=>{
          var date = new Date(item.timestamp);
          // 获取年、月、日、时、分、秒
          var year = date.getFullYear();
          var month = String(date.getMonth() + 1).padStart(2, "0");
          var day = String(date.getDate()).padStart(2, "0");
          var hours = String(date.getHours()).padStart(2, "0");
          var minutes = String(date.getMinutes()).padStart(2, "0");
          var seconds = String(date.getSeconds()).padStart(2, "0");
          var formattedTimestamp = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
          newArray.push({
            content:item.message_question,
            role:"user",
            time:formattedTimestamp,
          })
          newArray.push({
            ...item,
            id:item.message_id,
            content:item.message_answer,
            role:"assistant",
            time:formattedTimestamp,
            feedback:item.user_feedback
          })
        })
        setChatList(newArray)
      }
      else if(res.data.length > 0 && res.data.length <= 3){
        res.data.slice().forEach((item)=>{
          var date = new Date(item.timestamp);
          // 获取年、月、日、时、分、秒
          var year = date.getFullYear();
          var month = String(date.getMonth() + 1).padStart(2, "0");
          var day = String(date.getDate()).padStart(2, "0");
          var hours = String(date.getHours()).padStart(2, "0");
          var minutes = String(date.getMinutes()).padStart(2, "0");
          var seconds = String(date.getSeconds()).padStart(2, "0");
          var formattedTimestamp = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
          newArray.push({
            id:item.message_id,
            content:item.message_question,
            role:"user",
            time:formattedTimestamp,
          })
          newArray.push({
            ...item,
            id:item.message_id,
            content:item.message_answer,
            role:"assistant",
            time:formattedTimestamp,
            feedback:item.user_feedback
          })
        })
        setChatList(newArray)
      }
    })
    .catch((err)=>{
      if(err.response){
        if(err.response.status == 403){
          alert('Authorization expire, please login again')
          console.log('here clear');
          setContextUser(null);
          localStorage.clear();
          navigate('/login');
        }
      }
      console.log(err)
    })
  }, [])
  useEffect(()=>{
    if (scrollableDivRef.current) {
      const scrollableDiv = scrollableDivRef.current;
      scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
    }
  },[chatList])
  function getCurrentTime() {
    const date = new Date();
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, "0");
    var day = String(date.getDate()).padStart(2, "0");
    var hours = String(date.getHours()).padStart(2, "0");
    var minutes = String(date.getMinutes()).padStart(2, "0");
    var seconds = String(date.getSeconds()).padStart(2, "0");
    var formattedTimestamp = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return formattedTimestamp;
  }


  const callChatAPI = (inputValue) => {

    setChatgptLogging(true)
    axios.post(`${apiUrl}chatting/createHistory`, {
      question:inputValue,
      id:user.user_id,
      access:"private",
      user:user.user_name
    },{
      headers: {
        authorization: `Bearer ${user.accessToken}`,
      },
    })
    .then(res=>{
      // 将API回复添加到消息列表
      const time = getCurrentTime()
      setChatgptLogging(false)
      const newList = [...chatList,{
        role:"user", 
        content:inputValue,
        time:time
      }]
      console.log('res.data', res.data)
      setChatList([...newList,{
        ...res.data,
        id:res.data.message_id,
        role:"assistant", 
        content:res.data.message_answer,
        time:getCurrentTime(),
        feedback:res.data.user_feedback,
      }])
      // AddNewChat([{
      //   role:"assistant", 
      //   content:res.data.message_answer,
      //   time:getCurrentTime()
      // }])
    })
    .catch(err=>{
      console.log(err)
      alert(err)
      setChatgptLogging(false)
    })
  }
  const updateFeedback = (msgId, feedback)=>{
    const newCL = JSON.parse(JSON.stringify(chatList));
    newCL.forEach((item)=>{
      if(item.id === msgId){
        item.feedback = feedback
      }
    })
    console.log('newCL', newCL);
    setChatList(newCL);
  }
    //speak button click
    const handleSpeakClick = async (e)=>{
      setIsSpeaking(true);
      setChatgptLogging(true)
      const constraints = {
        audio: true,
      };
      try{
        try{
          stream.current = await navigator.mediaDevices.getUserMedia(constraints);
        }catch(_){
          throw new Error('No microphone detected')
        }

        record.current = new MediaRecorder(stream.current); //the MediaRecorder interface of the MediaStream Recording
        // record.current.start();

        record.current.ondataavailable = (event) => {
          //store audio Blob object
          blobs.current.push(event.data);
        };
        record.current.onstop  = (event) => {
          blob.current = new Blob(blobs.current, { type: 'audio/mp3' }); // wav
          const audioFile = new File([blob.current], 'recorded_speech')
          const reader = new FileReader();

          reader.onloadend = async ()=>{
            const base64 = reader.result.split(',')[1];
            try{
              const res = await axios.post(`${apiUrlChat}/speech/speechToText/`, {
                audio:base64,
              })
              setInputValue(res.data.text);
            }catch(e){
              message.error('Speech to text service unavailable now, please input your question.')
            }
          }
          reader.readAsDataURL(audioFile);
          blobs.current = []
        };
        record.current.start();

        // const listTracks = stream.getAudioTracks();
        // console.log('total audio track number is: ', listTracks.length);

        // const res = await axios.post(`${apiUrl}speechToText`, {
        //   id:user.user_id,
        // })
        // console.log("speechToText", res.data);
  
        // setInputValue(res.data);
      }catch(err){
        message.error(err.message);
        setIsSpeaking(false);
      }finally{
        setChatgptLogging(false)
      }
    }

    const handleSpeakStopClick = (e)=>{
      // console.log('stream.current', stream.current);
      // const tracks  = stream.current.getAudioTracks();
      // console.log('tracks', tracks);

      // tracks.forEach((track) => {
      //   track.stop();
      // });
      // console.log('in stop speak2')
      if(!isSpeaking){
        message.info('Please press Mic icon to start first');
        return;
      }
      record.current.stop();
      stream.current.getAudioTracks().forEach(track => track.stop());
      setIsSpeaking(false);
    }
      // 触发事件
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const handleSubmit = async (e) => {
    e.preventDefault(); 
    if (inputValue.trim() === '') {
      return;
    }
      // setChatList(()=>{
    //   const time = getCurrentTime()
    //   if(inputValue){
    //     setChatList([...chatList,{
    //       role:"user", 
    //       content:inputValue, 
    //       time
    //     }])
    //     setInputValue('')
    //   }
    // })
    const time = getCurrentTime()
    if(inputValue){
      setChatList([...chatList,{
        role:"user", 
        content:inputValue, 
        time
      }])
      setInputValue('')
    }
    try {
      await callChatAPI(inputValue);
    } catch (error) {
      alert('Error fetching chat response:', error);
    }
  };

  const onClose = () => {
    setOpen(false);
  };

  const dropMenuClick = ({key })=>{
    console.log('key is', key);
    setShowSelect(true);
  }

  const handleCancelClick = ()=>{
    setShowSelect(false);
  }

  const handleCheckbox = (index)=>{
    console.log('index is', index);
    const newSet = new Set(selectedSet);
    if(selectedSet.has(index)){
      newSet.delete(index)
    }else{
      newSet.add(index);
    }
    setSelectedSet(newSet);
  }

  const handleDelete = async ()=>{
    const newCL = chatList.slice();
    for (let i = newCL.length - 1; i >= 0; i--) {
      if (selectedSet.has(newCL[i].id)) {
        newCL.splice(i,1);
      }
    }
    console.log('user.user_id', user.user_id)
    console.log('historyList', Array.from(selectedSet))

    const res = await axios.post(`${apiUrl}chatting/deleteHistory`, {
      id: user.user_id,
      historyList: Array.from(selectedSet)
    },{
      headers: {
        authorization: `Bearer ${user.accessToken}`,
      },
    })
    if(res.flag === 'success'){
      setChatList(newCL);
      setSelectedSet(new Set());
      setShowSelect(false);
    }
  }

console.log('render')
// const t = true;
// if(t){
//   return(<div>haha</div>)

// }
  return (
    <div className='d-flex justify-content-between flex-column home align-items-center'>
        <div className='container mt-5 d-flex justify-content-between home-header p-0'>
          <Menu/>
          <div className="menu-welcome w-100 d-flex justify-content-end align-items-end"> 
            Welcome, {user ? user.user_name : ""}
          </div>
        </div>
        <div ref={scrollableDivRef} className='w-100 home-scroll container'>
          {
            showSelect ? 
              <Button className='home-cancel' type="dashed" ghost onClick={handleCancelClick}>Cancel</Button>
            :
              <Dropdown menu={{ items,  onClick: dropMenuClick}} className='home-popover' trigger={['click']}>
                <EllipsisOutlined onClick={(e) => e.preventDefault()}/>
              </Dropdown>
          }
          
          {
            chatList && chatList.length > 0 ?
            chatList.map((item, index)=>{
              if(item.role && item.role === 'user'){
                return(
                  <div key={item.id + '_' + item.role} className='home-user-message'>
                    <div className='w-100 d-flex justify-content-end'>
                      <div className='home-chat-user'>
                      <div dangerouslySetInnerHTML={{ __html: item.content.replace(/\n/g, "<br>") }}></div>
                      <div className='w-100 d-flex justify-content-end'>{item.time}</div>
                      </div>
                    </div>
                    {
                      showSelect && <Checkbox onChange={()=>handleCheckbox(item.id)}/>
                    }
                  </div>
                )
              }
              else if(item.role && item.role === 'assistant'){
                return(
                  <div key={item.id+"_"+ item.role +item.feedback} className='d-flex flex-row'>
                    <div className={`d-flex flex-column justify-content-start home-chat-assistant ${item.prompt_number === 0 ? 'chatgpt-assistant':''}`}>
                    <div dangerouslySetInnerHTML={{ __html: item.content.replace(/\n/g, "<br>") }}></div>
                      <div className='w-100 d-flex justify-content-end'>
                        {item.time}
                      </div>
                    </div>
                    <Feedbacks updateFeedback={updateFeedback} setOpen={setOpen} setContent={setContent} {...item}/>
                  </div>
                )
              }
            })
            :
            null
          }
          <Drawer title='The most relative sources' placement="right" onClose={onClose} open={open}>
            {content}
          </Drawer>
          {
            chatgptlLogging ?
            <div className='d-flex justify-content-start home-chat-assistant'>
              waiting
            </div>
            :
            null
          }
        </div>
        <div className='w-100 mb-5 home-chat container p-0'>
          {
            showSelect ? 
            <div className='w-100 home-submit '>
              <Flex justify='space-around' align='center' className='home-submit-input w-100'>
                <Button disabled={selectedSet.size === 0} onClick={handleDelete}>Delete</Button>
              </Flex>
            </div>
            :
            <form onSubmit={handleSubmit}>
              <div className='w-100 home-submit '>
                <input
                  className='home-submit-input w-100'
                  type="text"
                  value={inputValue}
                  onChange={handleInputChange}
                  placeholder="Send a message"
                  disabled={chatgptlLogging}/>
                {isSpeaking && <button disabled={chatgptlLogging} type="button" className='home-speak-button' onClick={handleSpeakStopClick}>
                  <img src={require('../../assets/images/stop.png')} alt="stop" style={{width:"90%",height:"90%"}}/>
                </button>}
                {!isSpeaking && <button disabled={chatgptlLogging} type="button" className='home-speak-button' onClick={handleSpeakClick}>
                  <img src={require('../../assets/images/speak3.png')} alt="speak" style={{width:"90%",height:"90%"}}/>
                </button>}
                <button disabled={chatgptlLogging} type="submit" className='home-submit-button'>
                  <img src={require('../../assets/images/sent.png')} alt="" style={{width:"90%",height:"90%"}}/>
                </button>
              </div>
            </form>
          }

        </div>
    </div>
  )
}

// const mapStateToProps = (state) => ({
//   chat: state.chat,
//   user: state.auth.user
// });

// const mapDispatchToProps = {
//   AddNewChat
// };

// export default connect(mapStateToProps, mapDispatchToProps)(Home);
export default Home;
